import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { MapPinIcon, XIcon } from 'lucide-react';
import { recentPurchases } from '../data/content';
export function PurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const reduce = useReducedMotion();
  useEffect(() => {
    if (dismissed) return;
    const show = window.setTimeout(() => setVisible(true), 4000);
    const cycle = window.setInterval(() => {
      setVisible(false);
      window.setTimeout(() => {
        setIndex(i => (i + 1) % recentPurchases.length);
        setVisible(true);
      }, 600);
    }, 9000);
    return () => {
      window.clearTimeout(show);
      window.clearInterval(cycle);
    };
  }, [dismissed]);
  const p = recentPurchases[index];
  return <div className="pointer-events-none fixed bottom-3 left-3 z-50 max-w-[calc(100vw-1.5rem)] sm:bottom-4 sm:left-4" aria-live="polite" data-id="element-144" data-mp="b4d8qfuod53j">
      <AnimatePresence data-id="element-145" data-mp="1u5zjd3935bgw">
        {visible && !dismissed && <motion.div key={index} initial={{
        opacity: 0,
        y: reduce ? 0 : 12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: reduce ? 0 : 8
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl border-2 border-ink bg-cream py-3 pl-3 pr-9 shadow-[4px_4px_0_0_#141210]" data-id="element-146" data-mp="1z5cai06zp4pa">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-kraft" data-id="element-147" data-mp="1fhl9i8d94mqu">
              <MapPinIcon className="h-5 w-5" aria-hidden="true" data-id="element-148" data-mp="1kgy79o5nve87" />
            </span>
            <div className="text-sm leading-tight" data-id="element-149" data-mp="1kev6c92z00op">
              <p className="font-display font-extrabold" data-id="element-150" data-mp="1p86h2lawl1lw">
                {p.name} from {p.place}
              </p>
              <p className="text-ink-soft" data-id="element-151" data-mp="rrhgeuxow5e3">Just bought the journal</p>
              <p className="mt-0.5 text-xs text-kraft-dark" data-id="element-152" data-mp="wqc1y4n1k81w">{p.ago}</p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="absolute right-2 top-2 rounded-full p-1 text-ink-soft hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-rust" data-id="element-153" data-mp="201hm7kluwv3k">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-154" data-mp="28tjkbc8gdzao" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}